import React from 'react';
import MerchandiseIcon from 'assets/merchandise.svg';
import TransactionIcon from 'assets/transaction.svg';
import ManagementIcon from 'assets/management.svg';
import ForSaleIcon from 'assets/for-sale.svg';
export const MerchandiseLogo = () => <img alt="logo" src={MerchandiseIcon} />;
export const TransactionLogo = () => <img alt="logo" src={TransactionIcon} />;
export const ManagementLogo = () => <img alt="logo" src={ManagementIcon} />;
export const ForSaleLogo = () => <img alt="logo" src={ForSaleIcon} />;
